export default __webpack_public_path__ + "static/media/2461.eadda078.png";